import { AuthorizationTokenSelectSchema, CustomerLoginCodeSelectSchema, } from "@norskgassnett/db";
import { z } from "zod";
import { StatusOk } from "../_core.js";
import { CustomerCustom } from "../business_central.js";
export const Identity = z
    .object({
    customer: CustomerCustom.optional(),
    bcId: CustomerCustom.shape.id.optional(),
})
    .meta({ ref: "Identity" });
export const ReauthenticateResponseBody = z
    .object({
    token: AuthorizationTokenSelectSchema.shape.token,
    expiresIn: z.number(),
})
    .meta({ ref: "ReauthenticateResponseBody" });
export const SwitchCustomerRequestBody = z
    .object({
    bcId: z.string(),
})
    .meta({ ref: "SwitchCustomerRequestBody" });
export const SwitchCustomerResponseBody = ReauthenticateResponseBody.meta({
    ref: "SwitchCustomerResponseBody",
});
export const ParsedCustomer = z
    .object({
    bcId: z.string(),
    name: z.string(),
    address: z.string(),
})
    .meta({ ref: "ParsedCustomer" });
export const MeResponseBody = z
    .object({
    current: CustomerCustom,
    linked: ParsedCustomer.array(),
})
    .meta({ ref: "MeResponseBody" });
export const StartLoginCustomerFlowRequestBody = z
    .object({
    value: CustomerLoginCodeSelectSchema.shape.identifier.toLowerCase(),
    type: CustomerLoginCodeSelectSchema.shape.type,
})
    .meta({ ref: "StartLoginCustomerFlowRequestBody" });
export const StartLoginCustomerFlowResponseBody = StatusOk.meta({
    ref: "StartLoginCustomerFlowResponseBody",
});
export const CompleteLoginCustomerFlowRequestBody = z
    .object({
    value: CustomerLoginCodeSelectSchema.shape.identifier,
    code: CustomerLoginCodeSelectSchema.shape.code.regex(/^[0-9]{6}$/, {
        message: "Invalid code format",
    }),
})
    .meta({ ref: "CompleteLoginCustomerFlowRequestBody" });
export const CompleteLoginCustomerFlowResponseBody = z
    .object({
    token: AuthorizationTokenSelectSchema.shape.token,
    expiresIn: z.number(),
})
    .meta({ ref: "CompleteLoginCustomerFlowResponseBody" });
